import * as analytics from "analytics";
import * as notificationUtils from "notificationUtils";
import readlangClient from "readlangClient";
import type { AppStores } from "stores/stores";

/**
 * reminderReprompt2 experiment: when the daily goal is met on the reader page,
 * the experiment arm gets the streak indicator's own popover opened once, with
 * a congratulation and the daily reminder checkbox. Control is treated at the
 * same moment and sees nothing. See
 * docs/experiments/2026-10-reminderReprompt2.md.
 */

/**
 * Called by the reader page at the streak goal-met transition. Resolves true
 * when the prompt should open now. The server checks eligibility, records the
 * treatment and then makes the once-ever claim, which lets only one tab or
 * device through (src/streakReminderPrompt.js).
 */
export const claimAtGoalMet = async (stores: AppStores): Promise<boolean> => {
  if (!window.READLANG.userID || stores.user.isLocalMode.value) return false;
  const { data } = await readlangClient.request<{ show: boolean }>(
    "POST",
    "/api/user/claimStreakReminderPrompt",
    {}
  );
  return data.show;
};

export const trackShown = () => {
  analytics.trackEvent("streakReminderPromptShown");
};

/**
 * Opting in also closes the popover (the confirmation dialog replaces it), so
 * a close only counts as a dismissal while reminders are still off.
 */
export const trackClosed = () => {
  if (!notificationUtils.has("dailyReminder", undefined)) {
    analytics.trackEvent("streakReminderPromptDismissed");
  }
};
